import React from "react";
import { Link } from "react-router-dom";
import corporateCleaningImg from "../../components/images/stage_01/corporate_cleaning.png";
import electricalMain169Img from "../../components/images/stage_01/electrical_main_169.png";
import completeHouseCleaningImg from "../../components/images/stage_01/complete_house_cleaning.png";
import deepCleaningMain169Img from "../../components/images/stage_01/deep_cleaning_169.png";
import platinumPackageMainImg from "../../components/images/stage_01/platinum_package_main.png";
import CategorySidebar from "./CategorySidebar";

const fallbackImage =
  "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=80";

// While Corporate Services itself is Coming Soon, point visitors at the
// closest related add-on services already live on the site — technical
// repair/installation work and home/deep cleaning.
const addOnServices = [
  { name: "Technical Services", desc: "Electrician, AC service, repairs & installations", link: "/services/technical-services", image: electricalMain169Img },
  { name: "Home Cleaning",      desc: "Regular home & kitchen cleaning",                  link: "/services/instant-home-services", image: completeHouseCleaningImg },
  { name: "Deep Cleaning",      desc: "Full intensive cleaning for office or home",        link: "/service/special-service/deep-cleaning", image: deepCleaningMain169Img },
];

// ─── Main Component ───────────────────────────────────────────────────────────
const CorporateServices = () => {
  return (
    <div style={styles.page}>
      <div style={styles.layout}>

        {/* Sidebar */}
        <aside style={styles.sidebar}>
          <CategorySidebar />
          <div style={styles.helpCard}>
            <h4 style={styles.helpTitle}>Need a Custom Business Plan?</h4>
            <p style={styles.helpText}>Our team can tailor a package for your office, factory or facility</p>
            <button style={styles.chatBtn}>💬 Chat with Us</button>
            <div style={styles.helpIcon}>🎧</div>
          </div>
        </aside>

        {/* Main */}
        <main style={styles.main}>
          <div style={styles.breadcrumb}>Home &gt; Corporate Services</div>

          {/* Hero */}
          <div style={styles.heroCard}>
            <div style={styles.heroContent}>
              <h1 style={styles.heroTitle}>Corporate Services</h1>
              <p style={styles.heroText}>Reliable cleaning, facility and staffing solutions for businesses</p>
              <div style={styles.heroFeatures}>
                <span style={styles.heroFeature}>Verified Professionals</span>
                <span style={styles.heroFeature}>On-time Service</span>
                <span style={styles.heroFeature}>Transparent Pricing</span>
                <span style={styles.heroFeature}>Satisfaction Guarantee</span>
              </div>
            </div>
            <img
              src={corporateCleaningImg}
              alt="corporate services"
              style={styles.heroImage}
              onError={(e) => { e.currentTarget.src = fallbackImage; }}
            />
          </div>

          {/* Coming Soon */}
          <div style={styles.comingSoonCard}>
            <div style={styles.comingSoonIcon}>🎧</div>
            <h2 style={styles.comingSoonTitle}>Coming Soon</h2>
            <p style={styles.comingSoonText}>
              Corporate Services aren't available for booking yet — check back soon.
            </p>
          </div>

          {/* Add-on services available in the meantime */}
          <div style={styles.addOnSection}>
            <h3 style={styles.addOnTitle}>In the meantime, explore these add-on services</h3>
            <p style={styles.addOnSub}>Technical and cleaning support you can book right away.</p>
            <div style={styles.addOnGrid}>
              {addOnServices.map((item) => (
                <Link key={item.name} to={item.link} style={styles.addOnCardLink}>
                  <div style={styles.addOnCard}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={styles.addOnImage}
                      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = fallbackImage; }}
                    />
                    <div style={styles.addOnCardBody}>
                      <h4 style={styles.addOnName}>{item.name}</h4>
                      <p style={styles.addOnDesc}>{item.desc}</p>
                      <span style={styles.addOnLink}>Check Now →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Banner — Platinum (membership subscription upsell, same pattern
              as OutdoorServices.js's Bronze Package / TransportServicesComingSoon.js's
              Gold Package banners — slate/graphite accent for the "platinum"
              metal theme). */}
          <div style={styles.bannerCard}>
            <img
              src={platinumPackageMainImg}
              alt="Platinum"
              style={styles.bannerImage}
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = fallbackImage; }}
            />
            <div style={styles.bannerContent}>
              <span style={styles.bannerBadge}>Subscription Plan</span>
              <h3 style={styles.bannerTitle}>Platinum</h3>
              <p style={styles.bannerText}>26 visits every month, 3 hrs per visit</p>
              <ul style={styles.bannerList}>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> 26 Service Visits / Month (3 hrs each)</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> 2 Partners — Flexible Slot Timings</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Choose 1, 3, 6 or 12 Month Plans</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Free Rapid Pre/Post-Party / Pre/Post-Fest Service on 3+ Month Plans</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Free Product Kit on Every Tier</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Max Discount on Services</li>
              </ul>
            </div>
            <div style={styles.bannerAction}>
              <p style={styles.saveText}>Flexible Monthly Plans</p>
              <Link to="/subscription-plans/checkout/platinum-package" style={styles.bookNowBtnLink}>Book Now →</Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

// ─── Page styles ──────────────────────────────────────────────────────────────
const styles = {
  page:             { background: "#f8fafc", minHeight: "100vh", padding: "20px", fontFamily: "Arial, sans-serif", color: "#111827" },
  layout:           { maxWidth: "1300px", margin: "0 auto", display: "grid", gridTemplateColumns: "250px 1fr", gap: "20px", alignItems: "start" },
  sidebar:          { display: "flex", flexDirection: "column", gap: "18px" },
  helpCard:         { background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: "18px", padding: "18px", textAlign: "left" },
  helpTitle:        { margin: "0 0 8px", fontSize: "18px", fontWeight: 700 },
  helpText:         { margin: "0 0 14px", fontSize: "14px", color: "#6b7280", lineHeight: 1.6 },
  chatBtn:          { border: "none", background: "#fff", color: "#4f46e5", fontWeight: 700, borderRadius: "12px", padding: "12px 16px", cursor: "pointer" },
  helpIcon:         { fontSize: "54px", textAlign: "center", marginTop: "18px" },
  main:             { minWidth: 0 },
  breadcrumb:       { fontSize: "13px", color: "#9ca3af", marginBottom: "14px" },
  heroCard:         { display: "grid", gridTemplateColumns: "1.2fr 0.9fr", background: "#fff", border: "1px solid #e5e7eb", borderRadius: "22px", overflow: "hidden", marginBottom: "18px" },
  heroContent:      { padding: "26px" },
  heroTitle:        { margin: 0, fontSize: "42px", fontWeight: 800 },
  heroText:         { margin: "10px 0 18px", fontSize: "15px", color: "#6b7280" },
  heroFeatures:     { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "12px" },
  heroFeature:      { fontSize: "13px", color: "#4b5563", background: "#f8fafc", border: "1px solid #eef2f7", padding: "10px 12px", borderRadius: "12px", fontWeight: 600 },
  // Smaller box than the source photo's own 1:1 ratio (so the hero card
  // isn't oversized) — objectPosition "top" anchors the crop at the top so
  // the crop comes out of the bottom (legs/feet), never off the heads.
  heroImage:        { width: "100%", aspectRatio: "4 / 3", objectFit: "cover", objectPosition: "center top", display: "block" },
  comingSoonCard:   { background: "#fff", border: "1px solid #e5e7eb", borderRadius: "22px", padding: "60px 40px", textAlign: "center" },
  comingSoonIcon:   { fontSize: "48px", marginBottom: "14px" },
  comingSoonTitle:  { margin: "0 0 12px", fontSize: "28px", fontWeight: 800 },
  comingSoonText:   { margin: "0 auto 24px", maxWidth: "520px", fontSize: "15px", color: "#6b7280", lineHeight: 1.7 },

  addOnSection:     { marginTop: "32px" },
  addOnTitle:       { margin: "0 0 4px", fontSize: "22px", fontWeight: 800 },
  addOnSub:         { margin: "0 0 16px", fontSize: "14px", color: "#6b7280" },
  addOnGrid:        { display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: "16px" },
  addOnCardLink:    { textDecoration: "none", color: "inherit" },
  addOnCard:        { background: "#fff", border: "1px solid #e5e7eb", borderRadius: "18px", overflow: "hidden" },
  addOnImage:       { width: "100%", aspectRatio: "16 / 9", objectFit: "cover", display: "block" },
  addOnCardBody:    { padding: "16px" },
  addOnName:        { margin: "0 0 6px", fontSize: "16px", fontWeight: 700 },
  addOnDesc:        { margin: "0 0 12px", fontSize: "13px", color: "#6b7280", lineHeight: 1.5 },
  addOnLink:        { color: "#4f46e5", fontWeight: 700, fontSize: "13px" },

  // Platinum banner — same gradient-card pattern as OutdoorServices.js's
  // Bronze Package / TransportServicesComingSoon.js's Gold Package banners,
  // slate/graphite for the "platinum" metal theme.
  bannerCard:       { marginTop: "32px", background: "linear-gradient(135deg, #475569 0%, #1e293b 100%)", borderRadius: "20px", padding: "22px", display: "grid", gridTemplateColumns: "220px 1fr auto", gap: "24px", alignItems: "center", boxShadow: "0 14px 34px rgba(30,41,59,0.35)" },
  bannerImage:      { width: "100%", aspectRatio: "4 / 3", objectFit: "cover", borderRadius: "16px", display: "block", boxShadow: "0 6px 18px rgba(0,0,0,0.3)" },
  bannerContent:    {},
  bannerBadge:      { display: "inline-block", background: "rgba(255,255,255,0.18)", color: "#fff", fontSize: "11px", fontWeight: 800, letterSpacing: "0.6px", textTransform: "uppercase", padding: "5px 12px", borderRadius: "999px", marginBottom: "10px" },
  bannerTitle:      { margin: "0 0 6px", fontSize: "26px", fontWeight: 800, color: "#fff" },
  bannerText:       { margin: "0 0 14px", fontSize: "14px", color: "rgba(255,255,255,0.85)" },
  bannerList:       { margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: "8px" },
  bannerListItem:   { display: "flex", alignItems: "flex-start", gap: "8px", fontSize: "13.5px", fontWeight: 600, color: "#fff" },
  bannerCheckIcon:  { color: "#86efac", fontWeight: 900, flexShrink: 0 },
  bannerAction:     { textAlign: "center" },
  saveText:         { margin: "0 0 12px", fontSize: "12px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "rgba(255,255,255,0.8)" },
  bookNowBtnLink:   { display: "inline-flex", alignItems: "center", justifyContent: "center", border: "none", background: "#fff", color: "#1e293b", height: "50px", padding: "0 26px", borderRadius: "12px", fontWeight: 800, fontSize: "14.5px", cursor: "pointer", textDecoration: "none", whiteSpace: "nowrap", boxShadow: "0 6px 16px rgba(0,0,0,0.2)" },
};

export default CorporateServices;
